import axios from 'axios';

export default {
    name: 'search',
    component() {
        return {
          searchVal: "",
            
            init() {
                this.$watch("searchVal", (val) => {
                    if (val || val == "") {
                        this.startSearch();
                    }
                });

                setTimeout(() => {
                  let closeHeight = this.$root.querySelector('[data-close]').getBoundingClientRect().height; 
                  this.$root.querySelector("[data-search-scroll]").style.height = `calc(100svh - ${closeHeight}px)`;
                }, 100);

                addEventListener("resize", () => {
                  let closeHeight = this.$root.querySelector('[data-close]').getBoundingClientRect().height; 
                  this.$root.querySelector("[data-search-scroll]").style.height = `calc(100svh - ${closeHeight}px)`;

              });
            },

            startSearch() {
                const filters = new FormData(document.getElementById('search-filters'));
                const params = new URLSearchParams();
            
                // Append all the form data to the URL parameters
                filters.forEach((value, key) => {
                  params.append(key, value);
                  // console.log(params);
                });
            
                // Make the Axios request to fetch filtered search results

                axios.get('/search', { params: params })
                  .then(function (response) {
                    // If the request is successful, update the page with the new results
                    const resultsContainer = document.getElementById('search-results');
            
                    let div = document.createElement('div')
                    div.innerHTML = response.data;

                    // Update the search results HTML with the response data
                    resultsContainer.innerHTML = div.querySelector('#search-results').innerHTML;

                    div.remove();
                  })
                  .catch(function (error) {
                    console.error('Error fetching search results:', error);
                  });
            }
        }
    }
}

